import CustomAmplitudeClient from "../../js/custom-amplitude-client.d4b698d00c77.js";
import { PET_INSURANCE_SELECTOR_ID } from "./pet-insurance-selector.ccd8dfc77f6c.js";
import {
  OpenInsuranceSelectorEvent,
  bindHtmxInsuranceSwitching,
} from "../../js/insurance-selector-events.87d20ca02104.js";
import { Toast } from "../../js/toast.73af8352e0da.js";

// "Patient return" flow: re-collect insurance info when loading the page
// from a share button-generated URL (patient-return=1 param)
const urlParams = new URLSearchParams(window.location.search);
const pageConfigElement = document.getElementById("page-config");
const pageConfig = pageConfigElement
  ? JSON.parse(pageConfigElement.textContent)
  : {};
const customAmplitudeClient = pageConfig.analyticsUrl
  ? new CustomAmplitudeClient(pageConfig.analyticsUrl)
  : null;

if (urlParams.get("patient-return") === "1") {
  if (pageConfig.insuredVariant !== "insurance-cost-share") {
    document.dispatchEvent(
      new OpenInsuranceSelectorEvent(false, {
        navMethod: "patient-return",
      }),
    );
  }
}

const locationSelectors = document.querySelectorAll("pet-location-selector");
locationSelectors.forEach((selector) => {
  selector.addEventListener("change", (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set("location", e.target.value);
    window.location.href = url.toString();
  });
});

document.addEventListener("change", (e) => {
  if (e.target.id === PET_INSURANCE_SELECTOR_ID) {
    const url = new URL(window.location.href);
    url.searchParams.set("network_config", e.target.value);
    window.location.href = url.toString();
  }
});

document.addEventListener("click", (e) => {
  const button = e.target.closest("[data-action='open-insurance-dialog']");
  if (button) {
    document.dispatchEvent(
      new OpenInsuranceSelectorEvent(false, {
        navMethod: "cost-summary-button",
      }),
    );
  }
});

const sendAmplitudeEventForCTA = function (action) {
  if (customAmplitudeClient) {
    customAmplitudeClient.trackEngageContactProvider(
      action,
      "pet-details-page",
    );
  }
};

document.addEventListener("click", async (e) => {
  const button = e.target.closest("[data-action='share-estimate']");
  if (button) {
    const toast = new Toast();
    try {
      const pageConfigElement = document.getElementById("page-config");
      const pageConfig = pageConfigElement
        ? JSON.parse(pageConfigElement.textContent)
        : {};

      const url = new URL(window.location.href);

      // When insurance-cost-share users share a link, store that information on the URL
      // so we can prompt the member info form open when the link is visited
      if (pageConfig.insuredVariant === "insurance-cost-share") {
        url.searchParams.set("patient-return", "1");
      }

      await navigator.clipboard.writeText(url.toString());
      toast.showToast();
    } catch (error) {
      toast.showToast("Failed to copy link to clipboard", true);
    }
    sendAmplitudeEventForCTA("share-estimate");
  }
});

document.addEventListener("click", (e) => {
  const insuranceCta = e.target.closest("[data-insurance-cta]");
  if (insuranceCta) {
    document.dispatchEvent(
      new OpenInsuranceSelectorEvent(false, {
        navMethod: "insurance-cta",
      }),
    );
  }
});

bindHtmxInsuranceSwitching();

document.addEventListener("click", (e) => {
  const button = e.target.closest("[data-action='download-estimate']");
  if (button) {
    window.print();
    sendAmplitudeEventForCTA("download-estimate");
  }
});
